// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePost_wrapper__-haGF","create-post":"CreatePost_create-post__qztt+","form-group":"CreatePost_form-group__Y9bfx"};